(globalThis as any).global = globalThis;
(globalThis as any).process = { env: {} };
